<div
  class="landing-spinner"
  role="status"
  aria-live="polite"
  aria-label="Checking authentication"
>
  <div class="spinner-border" aria-hidden="true"></div>
  <span class="visually-hidden">Checking authentication</span>
</div>
